(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-play-spela/assets/system-selector/system-selector.js') >= 0) return;  svs.modules.push('/components/tipsen/route-play-spela/assets/system-selector/system-selector.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector,
  useDispatch = _ReactRedux.useDispatch;
const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect;
const _svs$components$tipse = svs.components.tipsen.engine.constants.systems,
  SYSTEM_MSYS = _svs$components$tipse.SYSTEM_MSYS,
  SYSTEM_RSYS = _svs$components$tipse.SYSTEM_RSYS,
  SYSTEM_USYS = _svs$components$tipse.SYSTEM_USYS,
  SYSTEM_REDUCERA_FRITT = _svs$components$tipse.SYSTEM_REDUCERA_FRITT;
const useCouponId = svs.components.tipsen.couponId.useCouponId;
const selectSystem = svs.components.tipsen.engine.actions.selectSystem;
const _svs$components$tipse2 = svs.components.tipsen.engine.selectors.couponSelectors,
  selectRSystem = _svs$components$tipse2.selectRSystem,
  selectUSystem = _svs$components$tipse2.selectUSystem,
  selectLastSelectedSystem = _svs$components$tipse2.selectLastSelectedSystem;
const _svs$components$tipse3 = svs.components.tipsen.engine.selectors.engineSelectors,
  selectRSystems = _svs$components$tipse3.selectRSystems,
  selectUSystems = _svs$components$tipse3.selectUSystems,
  selectSystemTypes = _svs$components$tipse3.selectSystemTypes;
const _svs$components$tipse4 = svs.components.tipsen.routePlaySpela.systemSelector,
  SystemSelectorComponent = _svs$components$tipse4.SystemSelectorComponent,
  SystemSelectorMenu = _svs$components$tipse4.SystemSelectorMenu,
  SystemReduceFree = _svs$components$tipse4.SystemReduceFree;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_SM = _svs$components$lbUti.BREAKPOINT_SM;
const SystemSelectorWrapper = svs.components.tipsen.routePlaySpela.systemSelector.SystemSelectorWrapper;
const SystemSelector = () => {
  const couponId = useCouponId();
  const rSystems = useSelector(selectRSystems);
  const uSystems = useSelector(selectUSystems);
  const systemTypes = useSelector(selectSystemTypes);
  const filteredSystemTypes = systemTypes.filter(sys => sys !== SYSTEM_MSYS);
  const rSystem = useSelector(state => selectRSystem(state, couponId));
  const uSystem = useSelector(state => selectUSystem(state, couponId));
  const isExtraSmall = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  const lastSelectedSys = useSelector(state => selectLastSelectedSystem(state, couponId));
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(selectSystem({
      systemTypes,
      couponId,
      system: lastSelectedSys,
      rSystem: lastSelectedSys === systemTypes.indexOf(SYSTEM_RSYS) ? rSystem : null,
      uSystem: lastSelectedSys === systemTypes.indexOf(SYSTEM_USYS) ? uSystem : null
    }));
  }, []);
  const onClickSys = (systemType, systemNum) => {
    if (systemNum === rSystem || systemNum === uSystem || !systemNum) {
      systemNum = null;
    }
    dispatch(selectSystem({
      systemTypes,
      couponId,
      system: systemTypes.indexOf(systemType),
      rSystem: systemType === SYSTEM_RSYS ? systemNum : null,
      uSystem: systemType === SYSTEM_USYS ? systemNum : null
    }));
  };
  const selectedSystem = lastSelectedSys === systemTypes.indexOf(SYSTEM_MSYS) ? SYSTEM_RSYS : systemTypes[lastSelectedSys];
  const _useState = useState(selectedSystem),
    _useState2 = _slicedToArray(_useState, 2),
    selectedItem = _useState2[0],
    setSelectedItem = _useState2[1];
  useEffect(() => {
    setSelectedItem(systemTypes[lastSelectedSys]);
  }, [lastSelectedSys, systemTypes]);
  const handleClick = target => {
    setSelectedItem(target);
    dispatch(selectSystem({
      systemTypes,
      couponId,
      system: systemTypes.indexOf(target)
    }));
  };
  return React.createElement("div", {
    className: "tipsen-system-selector"
  }, React.createElement(SystemSelectorWrapper, {
    elementClassName: isExtraSmall ? 'tipsen-systems-selector-menu-div' : 'tipsen-systems-selector-menu-paper',
    isExtraSmall: isExtraSmall
  }, isExtraSmall && React.createElement("div", {
    className: "tipsen-system-selector-heading f-center f-800 f-medium"
  }, "V\xE4lj System"), React.createElement(SystemSelectorMenu, {
    handleClick: handleClick,
    selectedItem: selectedItem,
    systems: filteredSystemTypes
  }), selectedItem === SYSTEM_RSYS && React.createElement(SystemSelectorComponent, {
    onClick: onClickSys,
    selectedItem: selectedItem,
    system: rSystem !== null && rSystem !== void 0 ? rSystem : rSystems[rSystem],
    systems: rSystems,
    systemType: SYSTEM_RSYS
  }), selectedItem === SYSTEM_USYS && React.createElement(SystemSelectorComponent, {
    onClick: onClickSys,
    selectedItem: selectedItem,
    system: uSystem !== null && uSystem !== void 0 ? uSystem : uSystems[uSystem],
    systems: uSystems,
    systemType: SYSTEM_USYS
  }), selectedItem === SYSTEM_REDUCERA_FRITT && React.createElement(SystemReduceFree, {
    isExtraSmall: isExtraSmall
  })));
};
setGlobal('svs.components.tipsen.routePlaySpela.systemSelector.SystemSelector', SystemSelector);

 })(window);